import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

// TODO: Make it in align with the global componets and use theme colors
const CssTextField = withStyles((theme) => ({
  root: {
    '& label.Mui-focused': {
      color: theme.palette.KenColors.primary,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.KenColors.primary,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme.palette.KenColors.neutral40,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.KenColors.neutral40,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.KenColors.primary,
      },
    },
  },
}))(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

function KenTextArea(props) {
  const classes = useStyles();

  const {
    id,
    placeholder,
    label,
    options,
    disabled,
    required,
    onChange,
    onBlur,
    onFocus,
    autofocus,
    readonly,
    value,
  } = props;

  return (
    // <form className={classes.root} noValidate>
    <CssTextField
      id={id}
      className={classes.margin}
      multiline={true}
      fullWidth={true}
      rows={options.rows}
      variant='outlined'
      placeholder={placeholder}
      label={label}
      disabled={disabled || readonly}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      autoFocus={autofocus}
      required={required}
    />
    // </form>
  );
}

KenTextArea.defaultProps = {
  autofocus: false,
  options: { rows: 6 },
};

export default KenTextArea;
